import $, { trim } from "jquery";
import axios from 'axios';

let intial_load = $('.posts_f063__posts').attr('data-intial-load');
let load = $('.posts_f063__posts').attr('data-load');

$('.posts_f063__loader_button').on('click', function() {
  if(!$(this).hasClass('loading')) {
    ajax_get_posts(load, 'dont-check-tags');
  }
});

$('.posts_f063__filters a').on('click', function(e){
  e.preventDefault();
  $('.posts_f063__loader').css({'display': 'flex'});
  $('.posts_f063__no_more_posts_text').css({'display': 'none'});

  $('.posts_f063__filters a').removeClass('active');
  $(this).addClass('active');
  $('.posts_f063__posts').attr('data-offset', 0);
  $('.posts_f063__posts_inner').html('');
  $('.posts_f063__posts').attr('data-category', $(this).text());
  $('.posts_f063__posts').attr('data-category-index', $(this).attr('data-category-index'));
  ajax_get_posts(intial_load, 'dont-check-tags');
});

$('.posts_f063__filters_mobile select').on('change', function(){
  $('.posts_f063__loader').css({'display': 'flex'});
  $('.posts_f063__no_more_posts_text').css({'display': 'none'});
  $('.posts_f063__posts').attr('data-offset', 0);
  $('.posts_f063__posts_inner').html('');
  $('.posts_f063__posts').attr('data-category', this.value);
  ajax_get_posts(intial_load, 'dont-check-tags');
});

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function ajax_get_posts(l, check_tags) {
  console.log('check_tags', check_tags);
  let offset = parseInt($('.posts_f063__posts').attr('data-offset'));
  let intial_load = parseInt($('.posts_f063__posts').attr('data-intial-load'));
  let load = parseInt($('.posts_f063__posts').attr('data-load'));
  let category = $('.posts_f063__posts').attr('data-category');
  let category_index = $('.posts_f063__posts').attr('data-category-index');
  let ad_image = $('.posts_f063__posts').attr('data-ad-image');
  let ad_link = $('.posts_f063__posts').attr('data-ad-link');
  let translation_read_more = $('.posts_f063__posts').attr('data-translation-read-more');
  let current_blog_id = $('.posts_f063__posts').attr('data-current-blog-id');
  let current_language = $('.posts_f063__posts').attr('data-current-language');
  let get_lang = $('.posts_f063__posts').attr('data-get-lang');

  let params = new URLSearchParams();
  params.append('action', 'get_posts_f063');
  params.append('load', l);
  params.append('offset', offset);
  params.append('category', category);
  params.append('category_index', category_index);
  params.append('ad_image', ad_image);
  params.append('ad_link', ad_link);
  params.append('translation_read_more', translation_read_more);
  params.append('current_blog_id', current_blog_id);
  params.append('current_language', current_language);
  params.append('get_lang', get_lang);

  $('.posts_f063__loader_button').addClass('loading');

  axios.post('/wp-admin/admin-ajax.php', params).then(res => {
    let $postsInner = $('.posts_f063__posts_inner');
    console.log(res.data);
    if (trim(res.data.data) == 'no posts') {
      $('.posts_f063__loader').css({'display': 'none'});
      $('.posts_f063__no_more_posts_text').css({'display': 'block'});
    } else {
      $postsInner.append(res.data.data);
      if(offset > 0) {
        $('.posts_f063__posts').attr('data-offset', offset + load );
      } else {
        $('.posts_f063__posts').attr('data-offset', intial_load );
      }
    //   if(appending) {
    //     $postsInner.append(res.data.data);
    //   } else {
    //     $postsInner.html(res.data.data);
    //   }
    //   // postsInner.innerHTML += res.data.data;
    //   window.scrollTo(0,scrollpos);
    }

    if(check_tags === 'check-tags') {
      checkifthereisatag();
      //scrollIfThereIsATag();
    }

    $('.posts_f063__loader_button').removeClass('loading');

    // document.querySelector('.posts').dataset.page++;
  });
}

if($('.posts_f063__loader_button').length) {
  ajax_get_posts(intial_load, 'check-tags');
}


function checkifthereisatag() {
  var tag = getParameterByName('tag'); // "lorem"
  
  $('.posts_f063__filters a').each(function(){
    if($(this).text() == tag) {
        $(this).click();
    }
  });
}

function scrollIfThereIsATag() {
  var tag = getParameterByName('tag'); // "lorem"
  if(tag.length) {
    $('html, body').animate({
      'scrollTop': $('#blog').offset().top - 140
    }, 0);
  }
}

// document.addEventListener("DOMContentLoaded", function(){
//   setTimeout(function(){
//     scrollIfThereIsATag();
//   }, 3000);
// });


